export interface SizeData {
  padding: string;
  fontSize: string;
  legend: string;
  label?: string;
}

// Get padding and fontsize per inputSize
export const getSizeData = (inputSize: string): SizeData => {
  if (inputSize === "large") {
    return {
      padding: "16.5px",
      fontSize: "16px",
      legend: "12px",
      label: "16px",
    };
  }
  if (inputSize === "medium") {
    return {
      padding: "11px",
      fontSize: "16px",
      legend: "12px",
      label: "11px",
    };
  }
  return {
    padding: "8px",
    fontSize: "16px",
    legend: "12px",
    label: "7px",
  };
};
